import React, { useContext } from 'react'
import FoodItem from './FoodItem'
import "./fooditem.css"
import RestaurentContext from '../../context/rest_context'

const FoodItemList = ({ foodCat }) => {
  const { filterRestItems } = useContext(RestaurentContext);
  const itemsList = filterRestItems.filter(item => item.menuId === foodCat.dbID);
  const uniqueArray = itemsList.filter((value, index) => itemsList.indexOf(value) === index);

  return (
    <>
      {
        uniqueArray.length != 0 &&
        <div className='food-items-list-container' id={`category-${foodCat.name}`} >
          <h3>{foodCat.name}</h3>
          {
            uniqueArray.map((item, index) => {
              return <FoodItem key={index} item={item} isLast={uniqueArray.length - 1 === index} />
            })
          }
        </div>
      }
    </>
  )
}

export default FoodItemList